module.exports = __webpack_public_path__ + "img/israel.2df82396.svg";